module.exports = __webpack_public_path__ + "static/media/adobeCreative.c8fb1aa9.png";